// import React from "react";
// import { toast, ToastContainer } from "react-toastify";
// import { WEB_BASE_URL } from "../../webbase";
// import cookie from "react-cookies";
// import Select from "react-select";

// class CreateMerchant extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       businessEmail: "",
//       dealerId: "",
//       formState: "",
//       password: "",
//       stateOptions: [
//         //states in Nigeria
//         { label: "Abia", value: "Abia" },
//         { label: "Adamawa", value: "Adamawa" },
//         { label: "Akwa Ibom", value: "Akwa Ibom" },
//         { label: "Anambra", value: "Anambra" },
//         { label: "Bauchi", value: "Bauchi" },
//         { label: "Bayelsa", value: "Bayelsa" },
//         { label: "Benue", value: "Benue" },
//         { label: "Borno", value: "Borno" },
//         { label: "Cross River", value: "Cross River" },
//         { label: "Delta", value: "Delta" },
//         { label: "Ebonyi", value: "Ebonyi" },
//         { label: "Edo", value: "Edo" },
//         { label: "Ekiti", value: "Ekiti" },
//         { label: "Enugu", value: "Enugu" },
//         { label: "Gombe", value: "Gombe" },
//         { label: "Imo", value: "Imo" },
//         { label: "Jigawa", value: "Jigawa" },
//         { label: "Kaduna", value: "Kaduna" },
//         { label: "Kano", value: "Kano" },
//         { label: "Katsina", value: "Katsina" },
//         { label: "Kebbi", value: "Kebbi" },
//         { label: "Kogi", value: "Kogi" },
//         { label: "Kwara", value: "Kwara" },
//         { label: "Lagos", value: "Lagos" },
//         { label: "Nasarawa", value: "Nasarawa" },
//         { label: "Niger", value: "Niger" },
//         { label: "Ogun", value: "Ogun" },
//         { label: "Ondo", value: "Ondo" },
//         { label: "Osun", value: "Osun" },
//         { label: "Oyo", value: "Oyo" },
//         { label: "Plateau", value: "Plateau" },
//         { label: "Rivers", value: "Rivers" },
//         { label: "Sokoto", value: "Sokoto" },
//         { label: "Taraba", value: "Taraba" },
//         { label: "Yobe", value: "Yobe" },
//         { label: "Zamfara", value: "Zamfara" },
//       ],
//       token: cookie.load("tokenAdmin"),
//     };

//     this.onChangeState = this.onChangeState.bind(this);
//   }

//   onSubmit = (event) => {
//     event.preventDefault();
//     const id = toast.loading("Please wait...");
//     const { businessEmail, businessName } = this.state;
//     if (this.state.formState == "") {
//       alert("State is invalid. Select a state");
//       return;
//     }
//     const { history } = this.props;
//     const data = {
//       bussinessEmail: businessEmail,
//       bussinessName: this.state.dealerId,
//       bussinessAlias: "",
//       states: this.state.formState,
//     };
//     console.log(data);
//     fetch(WEB_BASE_URL + "/admin/invite-dealer", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: this.state.token,
//       },
//       body: JSON.stringify(data),
//     })
//       .then((res) => res.json())
//       .then((res) => {
//         console.log(res);
//         if (res.status === "2000") {
//           toast.update(id, {
//             render: "Successfully Invited Dealer",
//             type: "success",
//             isLoading: false,
//           });
//           this.props.navigate("/logical/view-dealers");
//         } else {
//           toast.update(id, {
//             render: res.description,
//             type: "error",
//             isLoading: false,
//           });
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   onChangeState = (e) => {
//     this.setState({
//       formState: e.value,
//     });
//   };

//   render() {
//     const customStyles = {
//       menu: (provided, state) => ({
//         ...provided,
//         borderBottom: "1px dotted pink",
//         color: state.selectProps.menuColor,
//         padding: 18,
//       }),

//       control: (provided, { selectProps: { width } }) => ({
//         ...provided,
//         borderRadius: "1px",
//         padding: "2px 4px",
//         width: width,
//         minWidth: "310px",
//       }),
//     };
//     return (
//       <main className="page-content">
//         <ToastContainer
//           position="top-center"
//           autoClose={3000}
//           hideProgressBar={false}
//           newestOnTop={false}
//           closeOnClick
//           rtl={false}
//           pauseOnFocusLoss
//           draggable
//           pauseOnHover
//         />
//         <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
//           <div className="ps-3">
//             <nav aria-label="breadcrumb">
//               <ol className="breadcrumb mb-0 p-0">
//                 <li className="breadcrumb-item">
//                   <a href="javascript:;">
//                     <i className="bx bx-home-alt"></i>
//                   </a>
//                 </li>
//                 <li className="breadcrumb-item active" aria-current="page">
//                   Create a Topupcliq Merchant
//                 </li>
//               </ol>
//             </nav>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-body">
//             <form
//               autocomplete="off"
//               class="row g-3"
//               onSubmit={(event) => {
//                 this.onSubmit(event);
//               }}
//             >

//               <div class="col-6">
//                 <label class="form-label">Email</label>
//                 <input
//                   type="email"
//                   name="businessEmail"
//                   class="form-control"
//                   style={{ borderRadius: "17px" }}
//                   value={this.state.businessEmail}
//                   onChange={(event) => {
//                     this.setState({
//                       businessEmail: event.target.value,
//                     });
//                   }}
//                   required
//                 />
//               </div>
//               <div class="col-6">
//                 <label class="form-label">Password</label>
//                 <input
//                   type="password"
//                   name="password"
//                   class="form-control"
//                   style={{ borderRadius: "17px" }}
//                   value={this.state.password}
//                   onChange={(event) => {
//                     this.setState({
//                       password: event.target.value,
//                     });
//                   }}
//                   required
//                 />
//               </div>
//               <div class="col-6">
//                 <label class="form-label">DSP</label>
//                 <input
//                   type="text"
//                   name="dealerId"
//                   class="form-control"
//                   style={{ borderRadius: "17px" }}
//                   value={this.state.dealerId}
//                   onChange={(event) => {
//                     this.setState({ dealerId: event.target.value });
//                   }}
//                   required
//                 />
//               </div>
//               <div class="text-start">
//                 <input
//                   type="submit"
//                   class="btn btn-primary px-4"
//                   value="Invite Dealer"
//                 />
//               </div>
//             </form>
//           </div>
//         </div>
//       </main>
//     );
//   }

//   componentDidMount() { }
// }

// export default CreateMerchant;


import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";
import { WEB_BASE_URL, CLIQ_BASE_URL } from "../../webbase";
import cookie from "react-cookies";
import axios from 'axios';

function DailyLimit() {
  const token = cookie.load("token");
  const [transaction, setTransaction] = useState({})
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(!open)
  const [unit, setUnit] = useState('')
  const [data, setData] = useState('')
  const [logic, setLogic] = useState('')
  const [recharge, setRecharge] = useState('')
  const handleClose = () => setOpen(false)

  useEffect(() =>{
    axios
    .get(CLIQ_BASE_URL + "/api/v3/w3/daily-limits", {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      //check if data isnt null
      if (res.data.data !== null) {
         setTransaction(res.data.data)
      }
      else {
          setTransaction({})
      }
    })
    .catch((err) => {
      console.log(err);
    });
  },[token])
  
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
  });
  
  const onSubmit = (e) =>{
    e.preventDefault();
    const id = toast.loading("Please wait...");
    axios.post(CLIQ_BASE_URL + "/api/v3/w3/daily-limits",
    {
      "dailyUnits": unit,
      "dataDailyLimits": data,
      "logicalDaiyLimits": logic,
      "rechargeDailyLimit": recharge
    },
    {
      headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if (res.data.status === "2000") {
        toast.update(id, {
          render: res.data.description,
          type: "success",
          isLoading: false,
        });
        window.location.reload()
      } else {
        toast.update(id, {
          render: res.data.description,
          type: "error",
          isLoading: false,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
  }
  
  return (
    <main className="page-content">
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <div className="container-fluid px-4">
        <div className="page-header d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="fw-bold text-primary mb-1">Daily Limit Management</h2>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:;" className="text-decoration-none">
                    <i className="bx bx-home-alt me-1"></i>Dashboard
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Daily Limit</li>
              </ol>
            </nav>
          </div>
          <button 
            onClick={handleOpen} 
            className={`btn ${open ? 'btn-outline-danger' : 'btn-primary'} rounded-pill px-4 d-flex align-items-center`}
          >
            <i className={`bx ${open ? 'bx-x' : 'bx-plus'} me-2`}></i>
            {open ? 'Cancel' : "Configure Limits"}
          </button>
        </div>
        
        {open && (
          <div className="card shadow-sm border-0 mb-4 animate__animated animate__fadeIn">
            <div className="card-header bg-primary bg-gradient text-white py-3">
              <h5 className="mb-0">Configure Daily Transaction Limits</h5>
            </div>
            <div className="card-body p-4">
              <form onSubmit={onSubmit}>
                <div className="row g-4">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-floating">
                      <input
                        id="dailyUnits"
                        className="form-control rounded-3 border-0 bg-light"
                        type="text"
                        required
                        value={unit}
                        onChange={(e) => setUnit(e.target.value)}
                        placeholder="10"
                      />
                      <label htmlFor="dailyUnits" className="form-label">Daily Units</label>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-floating">
                      <input
                        id="dataLimit"
                        className="form-control rounded-3 border-0 bg-light"
                        type="text"
                        required
                        value={data}
                        onChange={(e) => setData(e.target.value)}
                        placeholder="10"
                      />
                      <label htmlFor="dataLimit" className="form-label">Data Daily Limit</label>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-floating">
                      <input
                        id="logicLimit"
                        className="form-control rounded-3 border-0 bg-light"
                        type="text"
                        required
                        value={logic}
                        onChange={(e) => setLogic(e.target.value)}
                        placeholder="10"
                      />
                      <label htmlFor="logicLimit" className="form-label">Logical Daily Limit</label>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-floating">
                      <input
                        id="rechargeLimit"
                        className="form-control rounded-3 border-0 bg-light"
                        type="text"
                        required
                        value={recharge}
                        onChange={(e) => setRecharge(e.target.value)}
                        placeholder="10"
                      />
                      <label htmlFor="rechargeLimit" className="form-label">Recharge Daily Limit</label>
                    </div>
                  </div>
                </div>
                <div className="mt-4 text-end">
                  <button type="submit" className="btn btn-primary rounded-pill px-5">
                    <i className="bx bx-save me-2"></i>Save Limits
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        <div className="row">
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fw-bold text-primary">Current Daily Limits</h5>
                <span className="badge bg-primary rounded-pill px-3 py-2">
                  <i className="bx bx-refresh me-1"></i>Last Updated: {new Date().toLocaleDateString()}
                </span>
              </div>
              <div className="card-body p-4">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 h-100">
                      <div className="d-flex align-items-center mb-3">
                        <div className="icon-box bg-primary text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{width: '48px', height: '48px'}}>
                          <i className="bx bx-coin-stack fs-4"></i>
                        </div>
                        <h6 className="mb-0 fw-bold">Basic Limits</h6>
                      </div>
                      <div className="list-group list-group-flush">
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Daily Units Logical :</span>
                          <span className="fw-bold">{transaction?.dailyUnits || '0'}</span>
                        </div>
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Onetime Limit:</span>
                          <span className="fw-bold">{formatter.format(transaction?.oneTimeLimit || 0)}</span>
                        </div>
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Daily Limit:</span>
                          <span className="fw-bold">{formatter.format(transaction?.dailyLimit || 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 bg-light rounded-3 h-100">
                      <div className="d-flex align-items-center mb-3">
                        <div className="icon-box bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{width: '48px', height: '48px'}}>
                          <i className="bx bx-shield-quarter fs-4"></i>
                        </div>
                        <h6 className="mb-0 fw-bold">BVN Verified Limits</h6>
                      </div>
                      <div className="list-group list-group-flush">
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Onetime Limit BVN:</span>
                          <span className="fw-bold">{formatter.format(transaction?.oneTimeLimitBvn || 0)}</span>
                        </div>
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Daily Limit BVN:</span>
                          <span className="fw-bold">{formatter.format(transaction?.dailyLimitBvn || 0)}</span>
                        </div>
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Bills Daily Limit BVN:</span>
                          <span className="fw-bold">{formatter.format(transaction?.billsDailyLimitsBvn || 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="p-3 bg-light rounded-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="icon-box bg-info text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{width: '48px', height: '48px'}}>
                          <i className="bx bx-receipt fs-4"></i>
                        </div>
                        <h6 className="mb-0 fw-bold">Bills Payment Limits</h6>
                      </div>
                      <div className="list-group list-group-flush">
                        <div className="list-group-item bg-transparent px-0 d-flex justify-content-between">
                          <span className="text-muted">Bills Daily Limit:</span>
                          <span className="fw-bold">{formatter.format(transaction?.billsDailyLimits || 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white py-3">
                <h5 className="mb-0 fw-bold text-primary">Limit Statistics</h5>
              </div>
              <div className="card-body p-4 d-flex flex-column justify-content-center">
                <div className="text-center mb-4">
                  <div className="display-4 fw-bold text-primary mb-2">{transaction?.dailyUnits || '0'}</div>
                  <p className="text-muted">Current Daily Unit Allocation</p>
                </div>
                <div className="progress mb-4" style={{height: '10px'}}>
                  <div className="progress-bar bg-primary" role="progressbar" style={{width: '75%'}} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="badge bg-light text-dark px-3 py-2">
                    <i className="bx bx-data me-1"></i>Data: {data || '0'}
                  </span>
                  <span className="badge bg-light text-dark px-3 py-2">
                    <i className="bx bx-chip me-1"></i>Logical: {logic || '0'}
                  </span>
                  <span className="badge bg-light text-dark px-3 py-2">
                    <i className="bx bx-credit-card me-1"></i>Recharge: {recharge || '0'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default DailyLimit